import _ from 'lodash';

const get = (state, stateKey) => _.get(state, `ffPage.${stateKey}`);

export const getMemberIds = (state) => get(state, 'memberIds');
export const getPageType = (state) => get(state, 'pageType');
export const isLoading = (state) => get(state, 'isLoading');
export const getTotalMembersCount = (state) => get(state, 'totalMembersCount');
export const getCursor = (state) => get(state, 'cursor');
export const getHasNext = (state) => get(state, 'hasNext');
